import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProjectDeadlineOverview from "./routes/ProjectDeadlineOverview";
import ProjectDeadlineAllSubmissions from "./routes/ProjectDeadlineAllSubmissions";
import ProjectSubmissionViewer from "./routes/ProjectSubmissionViewer";

export default store => {
  return {
    path: ":deadlineId",

    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./ProjectDeadline"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      ProjectDeadlineOverview(store),
      ProjectDeadlineAllSubmissions(store),
      ProjectSubmissionViewer(store), // all dynamic routes route here
    ],
  };
};
